import type { VirtualAppointmentOverviewOrder } from '../../../services/virtualAppointmentsOverview';

// The sorts the table exposes: Created via its header, due day as Upcoming's default.
export type OverviewSortKey = 'createdAt' | 'dueDate';

export interface OverviewSort {
    by: OverviewSortKey;
    order: VirtualAppointmentOverviewOrder;
}

export const NEWEST_FIRST: OverviewSort = { by: 'createdAt', order: 'desc' };
export const BY_DUE_DATE: OverviewSort = { by: 'dueDate', order: 'asc' };

// Clicking Created flips its direction, or switches to it newest first from another sort.
export function sortAfterHeaderClick(current: OverviewSort, column: OverviewSortKey): OverviewSort {
    if (column !== 'createdAt') return current;
    if (current.by !== 'createdAt') return NEWEST_FIRST;
    return { by: 'createdAt', order: current.order === 'desc' ? 'asc' : 'desc' };
}
